'use client';

import { useFieldContext } from '@/lib/form';
import { Label } from '@sapling/ui/components/ui/label';
import {
  RadioGroup,
  RadioGroupItem,
} from '@sapling/ui/components/ui/radio-group';
import { FieldError, fieldErrorId } from './field-error';

export function RadioGroupField({
  label,
  options,
}: {
  label: string;
  options: { value: string; label: string }[];
}) {
  const field = useFieldContext<string>();
  const hasErrors =
    field.state.meta.isTouched && field.state.meta.errors.length > 0;

  return (
    <div>
      <Label>{label} *</Label>
      <RadioGroup
        value={field.state.value}
        onValueChange={(val) => field.handleChange(val)}
        className="mt-2 flex gap-6"
        aria-invalid={hasErrors}
        aria-describedby={hasErrors ? fieldErrorId(field.name) : undefined}
      >
        {options.map((option) => (
          <div key={option.value} className="flex items-center space-x-2">
            <RadioGroupItem
              value={option.value}
              id={`${field.name}-${option.value}`}
            />
            <Label
              htmlFor={`${field.name}-${option.value}`}
              className="font-normal"
            >
              {option.label}
            </Label>
          </div>
        ))}
      </RadioGroup>
      <FieldError errors={field.state.meta.errors} fieldName={field.name} />
    </div>
  );
}
